import {ApplicationContext} from "../Provider/ApplicationProvider";
import {useContext} from "react";
export default function List({title, list}){
    const {selectedInfos, setSelectedInfos}=useContext(ApplicationContext);
    const handleCheckboxChange = (event, itemId, itemValue, itemType) => {
        if (event.target.checked) {
            setSelectedInfos([...selectedInfos, { id: itemId, tag: itemValue, dataType:itemType }]);
        } else {
            const updatedItems = selectedInfos.filter((item) => item.id !== itemId);
            setSelectedInfos(updatedItems);
        }
    };
    return(
        <div>
            <small className="text-light fw-semibold">{title}</small>
            <div className="demo-inline-spacing mt-3 mb-3">
                <div className="list-group">
                    {list.map((item, index) => (
                        <label className="list-group-item" key={index}>
                        <input className="form-check-input me-1" type="checkbox" value={item.id} onChange={(event) =>
                            handleCheckboxChange(event, item.id, item.tag, item.dataType)
                        }/>
                            {item.tag}
                        </label>
                    ))}
                </div>
            </div>
        </div>
    );
}